import { render, staticRenderFns } from "./app-console.vue?vue&type=template&id=56d8d1b2&scoped=true"
import script from "./app-console.vue?vue&type=script&lang=js"
export * from "./app-console.vue?vue&type=script&lang=js"
import style0 from "./app-console.vue?vue&type=style&index=0&id=56d8d1b2&prod&lang=scss"
import style1 from "./app-console.vue?vue&type=style&index=1&id=56d8d1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d8d1b2",
  null
  
)

export default component.exports